<template>
    <div class="chat-page">
        <titleBar :title="title" right-icon="person" @iconClick="barClickHandle"></titleBar>
        <div class="chat-container">
            <div class="chat-message-list" ref="chatMessageList">
                <messageItem v-for="message in currentMessageList"
                             style="margin-top: 20px"
                             :key="message.ID"
                             :message="message"></messageItem>
            </div>
        </div>
        <chatFooter :isPersonalChat="true"></chatFooter>
    </div>
</template>

<script>
	import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
	import titleBar from '../../components/titleBar';
	import chatFooter from '../../components/chatFooter';
	import messageItem from '../../components/messageItem';
	import { eventBus } from '@/main';
	export default {
		name: "personalChat",
		components: {
			titleBar,
			chatFooter,
			messageItem
		},
		data() {
			return {
				preScrollHeight: 0,
				isShowScrollButtomTips: false,
				// currentConversation: {}
			};
		},
		computed: {
			...mapState('instantMessaging', [
				'currentMessageList', 
				'isReady', 
				'currentConversation',
				'currentMemberList', 
				'currentUserProfile'
			]),
			...mapGetters('instantMessaging', ['toAccount']),
			title: {
				get() {
					if (!this.currentConversation.userProfile) {
						return this.currentConversation.groupProfile && this.currentConversation.groupProfile.name;
					}
					return this.currentConversation.userProfile.nick || this.currentConversation.userProfile.userID;
				},
				set(v) {
					console.log('vvvvv',  v);
				}
				}
		},
		watch: {

		},
		mounted() {
			// console.log('会话成员列表', this.currentMemberList)
			console.log('当前会话信息', this.currentConversation)
			this.getConversation(100);
			this.$bus.$on('scroll-bottom', this.scrollFooter);
		},
		beforeDestroy() {
		    // this.tim.logout();
		},
		beforeRouteLeave(to, from, next) {
			if (to.path === '/refund/refundDetail') {
				this.tim.logout();
			}
			next()
    	},
		methods: {
			...mapActions('instantMessaging', ['checkoutConversation']),
			...mapMutations('instantMessaging', ['updateCurrentUserRole']),
			barClickHandle() {
				console.log('点击图标');
			},
			scrollFooter(){
				let $el = this.$refs['chatMessageList'];
				if($el){
					this.$nextTick(()=>{
						$el.scrollTop = $el.scrollHeight
					})
				}
				this.$nextTick(() => {
					let messageListNode = this.$refs['chatMessageList'];
					if (!messageListNode) {
						return
					}
					messageListNode.scrollTop = messageListNode.scrollHeight;
					this.preScrollHeight = messageListNode.scrollHeight;
					this.isShowScrollButtomTips = false
				})
			},
			getConversation(time) {
				if (!this.isReady) {
					return setTimeout(() => {
						this.getConversation(time);
					}, time)
				}
				let query = this.$route.query;
				if (query.currentConversationType === 'C2C') {

					this.checkoutConversation(`C2C${query.chatId}`).then(() => {
						// this.currentConversation = this.$store.state.instantMessaging.currentConversation
						this.$nextTick(() => {
							this.scrollFooter('chatMessageList');
						});
					});

				} else if (query.currentConversationType === 'GROUP') {
					this.checkoutConversation(`GROUP${query.chatId}`).then(() => {
						// this.currentConversation = this.$store.state.instantMessaging.currentConversation
						this.$nextTick(() => {
							this.scrollFooter('chatMessageList');
						});
					});

				}

			}
		}
	}
</script>

<style scoped lang="less">
    .chat-page {
        height: 100%;
        width: 100%;
        position: absolute;
        display: flex;
        flex-direction: column;
    }
    .chat-container {
        width: 100%;
        flex: 1;
        overflow-y: hidden;

        .chat-message-list {
            width: 100%;
            height: 100%;
            padding: 12px;
            padding-bottom: 32px;
            overflow-y: auto;
            box-sizing: border-box;

            .chat-message_time {
                display: block;
                margin: 16px auto 12px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                color: #71747A;
                text-align: center;
                letter-spacing: 0;
            }
        }
    }
</style>
